import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import { GET_RECENT_TRANSACTIONS } from "../../Action/actionTypes";
import {
  notifyError,
} from "../../../Utils/Helper";
import { getRecentTransactionsDataFailure, getRecentTransactionsDataSuccess } from "../../Action";
import qs from 'qs';


function* getRecentTransactionRequest(actions) {
  try {
    const { currentPage, rowCount, status, action } = actions?.payload?.payload || {};


    const hasFilters = currentPage || rowCount || status || action;
    let queryParams = '';

    if (hasFilters) {
      const queryObj = {
        ...(currentPage && { currentPage }),
        ...(rowCount && { rowCount }),
        ...(status && { status }),
        ...(action && { action }),
      };
    
      queryParams = '?' + qs.stringify(queryObj, { arrayFormat: 'brackets' });
    }

    const { data } = yield call(API.get, `/getRecentTransactions${queryParams}`); 
    if (data?.meta?.code === 200) {
      yield put(getRecentTransactionsDataSuccess(data?.data));

      if (actions?.payload?.callback) {
      
        yield call(actions?.payload?.callback, data);
      }
    } else {
      yield put(getRecentTransactionsDataFailure());
      notifyError("Invalid Request");
    }
  } catch (error) {
    yield put(getRecentTransactionsDataFailure());
    notifyError("Invalid Request");
  }
}

export function* watchGetRecentTransactionDataAPI() {
  yield takeEvery(GET_RECENT_TRANSACTIONS, getRecentTransactionRequest);
}

export default function* rootSaga() {
  yield all([watchGetRecentTransactionDataAPI()]);
}